import { render } from "./PdpReplacement.vue?vue&type=template&id=bdbfb862"
import script from "./PdpReplacement.vue?vue&type=script&lang=js"
export * from "./PdpReplacement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__